import Environment from './Environment';
import Features from './Features';

// Kill switch, checked before the experiment so turning it off leaves no
// half-filled experiment behind.
const HOMEPAGE_V2_GATE = '2026-enable_homepage_v2';
// New-vs-old test
const HOMEPAGE_V2_EXPERIMENT = '2026_consumer_homepage_redesign';

/* Which homepage a visitor gets, and with it the navbar treatment that ships
   alongside it. Shared so the two can't disagree — the navbar renders on every
   route, and a second copy of these conditions would drift.

   logExposure MUST stay false everywhere except the homepage itself. The navbar
   is sitewide, so logging there would count PDP-only visitors who never saw
   either homepage and dilute the result toward null.

   Only call once the Statsig client is ready; before that every read returns its
   fallback. */
const showsHomepageV2 = ({ logExposure = false } = {}) => {
  if (Environment.store !== 'bump') {
    return false;
  }

  if (!Features.checkGate(HOMEPAGE_V2_GATE)) {
    return false;
  }

  // Always show new version in dev/QA
  if (Environment.getStatsigEnvironment !== 'production') {
    return true;
  }

  return (
    Features.getExperiment(HOMEPAGE_V2_EXPERIMENT, {
      disableExposureLog: !logExposure,
    }).get('showHomepageV2', false) === true
  );
};

export default { showsHomepageV2, HOMEPAGE_V2_GATE, HOMEPAGE_V2_EXPERIMENT };
